module.exports = __webpack_public_path__ + "img/scene3-6.c363621e.jpg";